import { http } from "./http"

export const createSub = (uid: number, dto: any) => 
  http.post<any, any>(`/loyalty/account/${uid}`, dto)

export const updateSub = (uid: number, dto: any) => 
  http.put<any, any>(`/loyalty/account/${uid}`, dto)

export const deleteSub = (uid: number, sid: number) => 
  http.delete<any, any>(`/loyalty/account/${uid}/subscribe/${sid}`)

export const uncancelSub = (uid: number) => 
  http.post<any, any>(`/loyalty/account/${uid}/subscribe/uncancel`)

export const cancelSub = (uid: number) => 
  http.post<any, any>(`/loyalty/account/${uid}/subscribe/cancel`)

export const createPayment = (dto: any) => 
  http.post<any, any>(`orders/payment/sub`, dto)
